<!--
 * @Author: yaolei
 * @Email: yl@miaomiaoce.com
 * @Date: 2020-05-06 11:28:35
-->
<template>
  <div class="container">
    <no-data class="no" v-if="reminderList.length === 0" :imgSrc="imgUrl" text="暂无自定义提醒"></no-data>
    <ul class="item-container" v-else>
      <van-swipe-cell v-for="(item, index) in reminderList" :key="item.id" :before-close="chooseSelectTip" :name="item.id">
        <li class="item-li" v-if="item.image_time < todayStart">
          <div class="item-time">提醒日期: {{timestampLocalToUtc(item.image_time, 'YY-MM-DD')}}</div>
          <div class="item-content">{{item.content}}</div>
        </li>
        <li class="item-li" @click="editReminder(item)" v-else>
          <div class="item-time">提醒日期: {{timestampLocalToUtc(item.image_time, 'YY-MM-DD')}}</div>
          <div class="item-content">{{item.content}}</div>
        </li>
        <template v-if="item.image_time >= todayStart" #right>
          <span class="item-delete">删除</span>
        </template>
      </van-swipe-cell>
    </ul>
    <div :class="{'btn_box': reminderList.length===0}">
      <h4 class="bottomTip">长按日历Home键("O")可显示/隐藏当天的自定义事件提醒</h4>
      <button class="btnsave" @click="goPage()">添加提醒</button>
    </div>
    <ttip-select v-if="showSelectTip" @cancel="cancel" @sure="sure" :text="deleteText"></ttip-select>
  </div>
</template>
<script>
import axios from 'axios'
import NavBar from '../../components/NavBar/NavBar.vue'
import MenuList from '../../components/MenuList/MenuList.vue'
import Common from '../../assets/js/common.js'
import TtipSelect from '../../components/TtipSelect/TtipSelect.vue'
import NoData from '../../components/NoData/NoData.vue'
const api = process.env.BASE_URL
const isLocal = Common.getEvn()

export default {
  data () {
    return {
      date: '',
      show: false,
      imgUrl: Common.staticHref() + 'img/pillsAlerm.jpg',
      showSelectTip: false,
      deleteText: '是否确认删除该提醒',
      delete_id: null,
      device_id: this.$route.query.id,
      device_id_ex: '',
      reminderList: [],
      todayStart: 0,
      tryTimes: 0
    }
  },
  components: {
    NavBar,
    MenuList,
    TtipSelect,
    NoData
  },
  methods: {
    leftClick () {
      this.$router.push({path: '/Setting'})
    },
    goPage () {
      this.$router.push({path: '/ReminderDetail', query: {iex: this.device_id_ex}})
    },
    getReminder (needToast) {
      if (needToast) {
        this.toast = this.$createToast({
          time: 0,
          txt: '正在更新提醒列表',
          mask: true
        }).show()
      }
      if (isLocal === 'local') {
        axios.post('/Calendar/api/device/userdefined/web/get/reminders/', {
          device_id_ex: this.device_id_ex
        })
          .then(this.getReminderSucess)
          .catch(this.getReminderError)
      } else {
        axios.post(api + '/Calendar/api/device/userdefined/web/get/reminders/', {
          device_id_ex: this.device_id_ex
        })
          .then(this.getReminderSucess)
          .catch(this.getReminderError)
      }
    },
    getReminderSucess (res) {
      const reData = res.data
      if (reData && reData.result === 0 && reData.info && reData.info.length > 0) {
        this.reminderList = reData.info.reverse()
      } else {
        this.reminderList = []
      }
      this.tryTimes = 0
      this.toast.hide()
    },
    getReminderError (err) {
      this.toast.hide()
      this.reminderList = []
      console.log(err)

      if (this.tryTimes < 2) {
        this.tryTimes++
        this.getReminder(true)
      }
    },
    getDeviceIdEx () {
      this.toast = this.$createToast({
        time: 0,
        txt: '正在获取提醒列表',
        mask: true
      }).show()
      let deviceIdEx = localStorage.getItem('max_device_id_ex')
      if (deviceIdEx) {
        this.device_id_ex = deviceIdEx
        this.getReminder()
      } else {
        let apiUrl = '',
          that = this
        if (isLocal === 'local') {
          apiUrl = '/Calendar/api/version/get/device/version/info/'
        } else {
          apiUrl = api + '/Calendar/api/version/get/device/version/info/'
        }
        axios.post(apiUrl, {
          device_id: that.device_id
        })
          .then(res => {
            let _res = res.data
            if (_res) {
              if (_res.result === 0) {
                that.device_id_ex = _res.info.device_id_ex
                that.getReminder()
              } else {
                that.toast.hide()
                console.log(_res.message)
              }
            }
          })
          .catch(error => {
            that.toast.hide()
            console.log(error)
          })
      }
    },
    timestampLocalToUtc (time, format) {
      return Common.timestampLocalToUtc(parseInt(time) * 1000, format)
    },
    deleteReminder () {
      let apiUrl = '',
        that = this
      that.toast = that.$createToast({
        time: 0,
        txt: '正在删除',
        mask: true
      }).show()
      if (isLocal === 'local') {
        apiUrl = '/Calendar/api/device/userdefined/del/reminders/'
      } else {
        apiUrl = api + '/Calendar/api/device/userdefined/del/reminders/'
      }
      axios.post(apiUrl, {
        device_id_ex: that.device_id_ex,
        reminder_id: that.delete_id
      })
        .then(res => {
          that.toast.hide()
          that.delete_id = null
          let _res = res.data
          if (_res && _res.result === 0) {
            that.toast = that.$createToast({
              txt: '删除成功',
              type: 'txt'
            }).show()
            that.getReminder(true)
          } else {
            console.log('删除失败res: ', _res)
            that.toast = that.$createToast({
              txt: '删除失败',
              type: 'txt'
            }).show()
          }
        })
        .catch(error => {
          that.toast.hide()
          that.delete_id = null
          console.log('删除失败err: ', error)
        })
    },
    cancel () {
      this.showSelectTip = false
      this.delete_id = null
    },
    sure () {
      this.showSelectTip = false
      this.deleteReminder()
    },
    chooseSelectTip ({ position, instance }) {
      switch (position) {
        case 'left':
        case 'cell':
        case 'outside':
          instance.close()
          break
        case 'right':
          this.showSelectTip = true
          this.delete_id = instance.name
          instance.close()
      }
    },
    getTodayStartOfUtc () {
      let date = new Date()
      let start = new Date('' + date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + (date.getDate()) + ' 00:00:00').getTime() / 1000
      let offset = new Date().getTimezoneOffset() * 60
      return start + offset
    },
    editReminder (data) {
      sessionStorage.setItem('max_reminder_edit', JSON.stringify(data))
      this.$router.push({
        path: '/ReminderDetail',
        query: {
          iex: this.device_id_ex,
          isEdit: 1
        }
      })
    }
  },
  created () {
    Common.setTitle('提醒列表')
    this.device_id = this.$route.query.id
    this.todayStart = this.getTodayStartOfUtc()
    if (this.device_id !== null) {
      this.getDeviceIdEx()
    }
  },
  activated () {
    this.getReminder(true)
  }
}
</script>
<style lang="stylus" scoped>
.btnsave
  background-color #000000
  margin-top 10px
  margin-left 20px
  width 89.3vw
  height 44px
  font-size 16px
  color #FFFFFF
.bottomTip
  color #F50B0B
  font-size 12px
  margin-top 20px
  text-align center
.no
  padding-top 30px!important
  padding-bottom 20px
.btn_box
  position absolute
  bottom 20px
  width 100%
.item-container
  height: calc(100% - 100px);
  overflow: auto;
.item-li
  padding 0 15px
  background-color #fff
  margin-top 15px
.item-time
  font-size 12px
  color #666
  line-height 17px
  padding-top 12px
  padding-bottom 11px
  border-bottom 1px solid #ddd
.item-content
  font-size 14px
  color #333
  line-height 20px
  padding-top 10px
  padding-bottom 15px
  width 100%
  text-overflow ellipsis
  overflow hidden
  white-space nowrap
.item-delete
  display block
  font-size 16px
  color #ffffff
  background-color #F50B0B
  height 86px
  line-height 86px
  text-align center
  width 75px
</style>



// WEBPACK FOOTER //
// src/pages/Reminder/ReminderList.vue